import React from "react";

import { splitMultipleStringList } from "@frontend/common/src/business/DatabaseTable/utils/splitMultipleStringList";

import { useCanEditGroupTable } from "@FillInTableContainer/shared/hooks/useCanEditGroupTable";

import * as S from "./AIAdvisorTable.style";
import AIAdvisorTableBodyCell from "./components/AIAdvisorTableBodyCell/AIAdvisorTableBodyCell";
import AIAdvisorTableHeader from "./components/AIAdvisorTableHeader/AIAdvisorTableHeader";
import { AIAdvisorData } from "../../types/AIAdvisorType.types";

type Props = {
  aiAdvisorData: AIAdvisorData;
};

const AIAdvisorTable = ({ aiAdvisorData }: Props) => {
  const { checkDisableEdit } = useCanEditGroupTable();
  const isDisableEdit = checkDisableEdit("Drug Profile");

  return (
    <S.TableLayout>
      <AIAdvisorTableHeader />
      {aiAdvisorData.aiAdviceData.map((item) => (
        <S.Row key={item.id} $isDisableEdit={isDisableEdit}>
          <AIAdvisorTableBodyCell
            value={splitMultipleStringList(item.drugIndex.toString())}
            maxWidth="8rem"
            minWidth="8rem"
            tooltipAlignment="left"
            isDisableEdit={isDisableEdit}
          />
          <AIAdvisorTableBodyCell
            value={splitMultipleStringList(item.drugKey)}
            maxWidth="14.4rem"
            tooltipAlignment="left"
            hasChangeButton
            changedValue={item.changedValue}
            drugIndex={item.drugIndex}
            drugKey={item.drugKey}
            isDisableEdit={isDisableEdit}
          />
          <AIAdvisorTableBodyCell
            value={splitMultipleStringList(item.changedValue)}
            maxWidth="28rem"
            tooltipAlignment="left"
            hasCopyButton
            drugKey={item.drugKey}
            drugIndex={item.drugIndex}
            isDisableEdit={isDisableEdit}
          />
          <AIAdvisorTableBodyCell
            value={splitMultipleStringList(item.reason)}
            minWidth="40rem"
            tooltipAlignment="center"
            isDisableEdit={isDisableEdit}
          />
          <AIAdvisorTableBodyCell
            value={splitMultipleStringList(item.sourceEvidence)}
            minWidth="40rem"
            tooltipAlignment="right"
            isDisableEdit={isDisableEdit}
          />
        </S.Row>
      ))}
    </S.TableLayout>
  );
};

export default AIAdvisorTable;
